module.exports = __webpack_public_path__ + "static/media/friday-che-routes-mobile.bd464cd7.png";